import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress MetaMask/Web3 extension errors that pollute the DOM/console
window.addEventListener('unhandledrejection', event => {
  if (
    event.reason &&
    typeof event.reason.message === 'string' &&
    event.reason.message.toLowerCase().includes('metamask')
  ) {
    event.preventDefault(); // Stop the error overlay
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
